// extracted by css-extract-rspack-plugin
export default {"container":"src-components-common-EmptyState-module__container-c6RGqj","fullHeight":"src-components-common-EmptyState-module__fullHeight-IgoygU"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-components-common-EmptyState-module__container-c6RGqj\",\"fullHeight\":\"src-components-common-EmptyState-module__fullHeight-IgoygU\"}";
        // 1773737314013
        var cssReload = require("../../../../../node_modules/.pnpm/@rspack+core@1.7.6_@swc+helpers@0.5.19/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  